import { msg } from "@lingui/core/macro";
import type { I18n } from "@lingui/core";

import { formatGameTime } from "../format/formatGameTime";
import type { FightDeath } from "../model/FightDeath";

const MOMENT = msg({
  id: "finding.fight_death.moment",
  message: "{time}: {mine} vs {theirs}, {seconds} s",
});

// Смерть в невыгодной драке одной фразой: «20:23: 1 против 5, 12 с».
export const fightMomentText = (moment: FightDeath, i18n: I18n): string =>
  i18n._({
    ...MOMENT,
    values: {
      time: formatGameTime(moment.time_s),
      mine: 1 + moment.ally_hero_ids.length,
      theirs: moment.enemy_hero_ids.length,
      seconds: moment.duration_s,
    },
  });
